import orderBy from 'lodash/orderBy';

import { UserDetailsActions, UsersTableActions, SecurityActions } from "../const/ActionsConst";

const initialState = {
    user: {username: '', firstName: '', lastName: '', email: '', profileFormat: '', locked: false, webClient: false, webAdmin: false, ambryIDs: []},
    profileFormats: [],
    security: []
};

const READONLY_SECURITY_FIELDS = ['All Users'];

const userDetails = (state = initialState, action) => {
    switch (action.type) {
        case UsersTableActions.USER_LOADED:
            return {
                ...state,
                user: {
                    ...action.user,
                    username: action.user.username || '',
                    firstName: action.user.firstName || '',
                    lastName: action.user.lastName || '',
                    email: action.user.email || '',
                    profileFormat: action.user.profileFormat || '',
                    locked: action.user.locked || false,
                    webClient: action.user.webClient || false,
                    webAdmin: action.user.webAdmin || false,
                    ambryIDs: action.user.ambryIDs || []
                }
            };
        case UserDetailsActions.UPDATE_INPUT:
            switch (action.property) {
                case "firstname":
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            firstName: action.value
                        }
                    };
                case "lastname":
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            lastName: action.value
                        }
                    };
                case "email":
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            email: action.value
                        }
                    };
                case "profilename":
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            profileFormat: action.value
                        }
                    };
                case 'locked':
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            locked: action.value
                        }
                    };
                case 'admin':
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            admin: action.value
                        }
                    };
                case 'enduseradmin':
                    return {
                        ...state,
                        user: {
                            ...state.user,
                            endUserAdmin: action.value
                        }
                    };
            }
            break;
        case UserDetailsActions.PROFILES_LOADED:
            return {
                ...state,
                profileFormats: action.profiles
            };
        case UserDetailsActions.CHANGE_AMBRY_ORG_NAME:
            var ambryIdIndex = state.user.ambryIDs.findIndex(ambryId => ambryId.profileId == action.id);
            var ambryIDs = state.user.ambryIDs;
            return {
                ...state,
                user: {
                    ...state.user,
                    ambryIDs: [
                        ...ambryIDs.slice(0, ambryIdIndex),
                        {...ambryIDs[ambryIdIndex], organizationName: action.value},
                        ...ambryIDs.slice(ambryIdIndex + 1)
                    ]
                }
            };
        case UserDetailsActions.CHANGE_AMBRY_CLIENT_ID:
            ambryIdIndex = state.user.ambryIDs.findIndex(ambryId => ambryId.profileId == action.id);
            ambryIDs = state.user.ambryIDs;
            return {
                ...state,
                user: {
                    ...state.user,
                    ambryIDs: [
                        ...ambryIDs.slice(0, ambryIdIndex),
                        {...ambryIDs[ambryIdIndex], clientID: action.value},
                        ...ambryIDs.slice(ambryIdIndex + 1)
                    ]
                }
            };
        case UserDetailsActions.ADD_AMBRY_PORT_ID:
            var profileId = -state.user.ambryIDs.filter(ambryId => ambryId.profileId < 0).length - 1;
            var newRow = {
                profileId: profileId,
                organizationName: '',
                clientID: ''
            };
            return {
                ...state,
                user: {
                    ...state.user,
                    ambryIDs: [
                        ...state.user.ambryIDs,
                        newRow
                    ]
                }
            };
        case UserDetailsActions.UPDATE_AMBRY_PROFILE_ID:
            ambryIdIndex = state.user.ambryIDs.findIndex(ambryId => ambryId.profileId == action.oldProfileId);
            ambryIDs = state.user.ambryIDs;
            return {
                ...state,
                user: {
                    ...state.user,
                    ambryIDs: [
                        ...ambryIDs.slice(0, ambryIdIndex),
                        {...ambryIDs[ambryIdIndex], profileId: action.newProfileId},
                        ...ambryIDs.slice(ambryIdIndex + 1)
                    ]
                }
            };
        case UserDetailsActions.REMOVE_AMBRY_PORT_ID:
            ambryIdIndex = state.user.ambryIDs.findIndex(ambryId => ambryId.profileId == action.id);
            ambryIDs = state.user.ambryIDs;
            return {
                ...state,
                user: {
                    ...state.user,
                    ambryIDs: [
                        ...ambryIDs.slice(0, ambryIdIndex),
                        ...ambryIDs.slice(ambryIdIndex + 1)
                    ]
                }
            };
        case UserDetailsActions.CLEAR_USER_DETAILS:
            return {
                ...state,
                user: {
                    username: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    profileFormat: '',
                    locked: false,
                    webClient: false,
                    webAdmin: false,
                    ambryIDs: []
                }
            };
        case UserDetailsActions.SAVE_LICENSING: 
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.licensing,
                }
            };
        case UserDetailsActions.SAVE_SECURITY: 
            return {
                ...state,
                user: {
                    ...state.user,
                    classes: action.userSecurity,
                }
            };
        case SecurityActions.SAVE: 
            return {
                ...state,
                security: (action.security || []).filter(({ name }) => !READONLY_SECURITY_FIELDS.includes(name)),
            };
        default:
            return state;
    }
};

export default userDetails;